import { cookieNameCreator } from 'utils/storage/cookies';

export const AUTH_CACHE_KEY = cookieNameCreator('essential', 'auth');
export const JAWS_TOKEN_CACHE_KEY = cookieNameCreator('essential', 'jaws');
